prbJsonp([1],{

/***/ "./client/js/article/applySelectorToOEmbeds.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var oEmbeds = document.querySelectorAll('iframe.wp-embedded-content[src*="datacenter.prb.org"]');

  Array.prototype.forEach.call(oEmbeds, function (oEmbed) {
    // Create new iframe with embedded content's properties
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', oEmbed.getAttribute('src'));
    iframe.classList.add('prb-embed-iframe');
    iframe.dataset.component = 'dynamicIframe';

    // Store reference to parent
    var parent = oEmbed.parentNode;

    // Always size this kind of element as full
    parent.classList.add('article-media--full');

    // Create embed wrapper
    var embedWrapper = document.createElement('div');
    embedWrapper.classList.add('embed-wrapper');

    // Delete reference to original embed
    oEmbed.remove();

    // Store new embed inside parent
    parent.appendChild(embedWrapper);
    embedWrapper.appendChild(iframe);
  });
};

/***/ }),

/***/ "./client/js/article/article.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

var _footnotesConfig = __webpack_require__("./client/js/components/Footnotes/footnotesConfig.js");

var _footnotesConfig2 = _interopRequireDefault(_footnotesConfig);

var _carouselConfig = __webpack_require__("./client/js/components/Carousel/carouselConfig.js");

var _carouselConfig2 = _interopRequireDefault(_carouselConfig);

var _articleToolbarConfig = __webpack_require__("./client/js/components/Header/articleToolbarConfig.js");

var _articleToolbarConfig2 = _interopRequireDefault(_articleToolbarConfig);

var _buttonCTAConfig = __webpack_require__("./client/js/components/ButtonCTA/buttonCTAConfig.js");

var _buttonCTAConfig2 = _interopRequireDefault(_buttonCTAConfig);

var _contactForm = __webpack_require__("./client/js/article/contactForm.js");

var _contactForm2 = _interopRequireDefault(_contactForm);

var _applySelectorToOEmbeds = __webpack_require__("./client/js/article/applySelectorToOEmbeds.js");

var _applySelectorToOEmbeds2 = _interopRequireDefault(_applySelectorToOEmbeds);

var _DynamicIframe = __webpack_require__("./client/js/components/DynamicIframe/index.js");

var _DynamicIframe2 = _interopRequireDefault(_DynamicIframe);

__webpack_require__("./client/scss/article/loader.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Negotiate the document.domain.


// Import components and manager here
if (document.domain.match(/\.prb\.org$/)) {
  document.domain = 'prb.org';
} else if (document.domain.match(/\.alley\.dev$/)) {
  document.domain = 'alley.dev';
}

// Create instance of the component manager using `wp-starter-theme`


// Import SCSS
/**
 * JS for articles (is_single() or is_singular())
 */
var manager = new _jsComponentFramework.ComponentManager('prb-2017');

var components = [_footnotesConfig2.default, _carouselConfig2.default, _articleToolbarConfig2.default, _buttonCTAConfig2.default, _DynamicIframe2.default];

// Initialize components here
document.addEventListener('DOMContentLoaded', function () {
  (0, _applySelectorToOEmbeds2.default)();
  manager.initComponents(components);
  (0, _contactForm2.default)();
});

// HMR Acceptance
if (false) {
  module.hot.accept();
  (0, _applySelectorToOEmbeds2.default)();
  manager.initComponents(components);
}

/***/ }),

/***/ "./client/js/article/contactForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  $('.prb-contact-form').submit(function prbContactFormSubmission(event) {
    event.preventDefault();
    var form = this;

    $.post(prb_site_vars.ajax_url, {
      action: 'prb_contact_form_submission',
      first_name: $(this).find('input[name="first-name"]').val(),
      last_name: $(this).find('input[name="last-name"]').val(),
      email: $(this).find('input[name="email"]').val(),
      remarks: $(this).find('textarea[name="remarks"]').val(),
      type: $(this).find('input[name="type"]:checked').val(),
      affiliation: $(this).find('input[name="affiliation"]').val(),
      nonce: prb_site_vars.contact_form_nonce
    }, function (response) {
      var formFeedback = $(form).find('.prb-contact-form-feedback');

      // Add the appropiate status.
      formFeedback.removeClass('has-success');
      formFeedback.removeClass('has-error');
      if (response.success) {
        formFeedback.addClass('has-success');
      } else {
        formFeedback.addClass('has-error');
      }

      // Add the text.
      formFeedback.find('.form-control-feedback').html(response.data.message);

      formFeedback.show();
    });
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ "./client/js/components/ButtonCTA/ButtonCTA.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

var _SmoothScroll = __webpack_require__("./client/js/utilities/SmoothScroll.js");

var _SmoothScroll2 = _interopRequireDefault(_SmoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating cta buttons.
 */
var ButtonCTA = function (_Component) {
  _inherits(ButtonCTA, _Component);

  /**
   * Start the component
   */
  function ButtonCTA(config) {
    _classCallCheck(this, ButtonCTA);

    var _this = _possibleConstructorReturn(this, (ButtonCTA.__proto__ || Object.getPrototypeOf(ButtonCTA)).call(this, config));

    _this.button = document.querySelector('.cta-button');

    // Initalizations
    if (_this.button.classList.contains('cta-button--slide')) {
      _this.init();
    }
    return _this;
  }

  /**
   * Init
   */


  _createClass(ButtonCTA, [{
    key: 'init',
    value: function init() {
      this.setSmoothScroll = new _SmoothScroll2.default('.cta-button--slide');
      this.setSmoothScroll.init();
    }
  }]);

  return ButtonCTA;
}(_jsComponentFramework.Component);

exports.default = ButtonCTA;

/***/ }),

/***/ "./client/js/components/ButtonCTA/buttonCTAConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonCTA = __webpack_require__("./client/js/components/ButtonCTA/ButtonCTA.js");

var _ButtonCTA2 = _interopRequireDefault(_ButtonCTA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonCTAConfig = {
  name: 'buttonCTA',
  class: _ButtonCTA2.default
};

exports.default = buttonCTAConfig;

/***/ }),

/***/ "./client/js/components/Carousel/Carousel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _siema = __webpack_require__("./node_modules/siema/dist/siema.min.js");

var _siema2 = _interopRequireDefault(_siema);

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating Carousel w/ Thumbs.
 */
var Carousel = function (_Component) {
  _inherits(Carousel, _Component);

  /**
   * Start the component
   */
  function Carousel(config) {
    _classCallCheck(this, Carousel);

    // Initalizations
    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, config));

    _this.setCarousel();
    _this.setPrevNextTriggers();
    _this.setCurrentSlide();
    return _this;
  }

  /**
   * Set Main and Navigation Carousels
   * @see https://pawelgrzybek.com/siema/
   */


  _createClass(Carousel, [{
    key: 'setCarousel',
    value: function setCarousel() {
      // Main Carousel
      this.carousel = new _siema2.default({
        selector: this.children.viewport,
        draggable: false,
        multipleDrag: false
      });

      // Navigation Carousel
      this.carouselNav = new _siema2.default({
        selector: this.children.navigationThumbWrapper,
        perPage: {
          0: 2,
          520: 3,
          620: 4
        },
        draggable: false,
        multipleDrag: false,
        loop: true
      });
    }

    /**
     * Set Prev/Next Buttons for Carousel Nav
     */

  }, {
    key: 'setPrevNextTriggers',
    value: function setPrevNextTriggers() {
      var _this2 = this;

      this.children.navigationPrev.addEventListener('click', function () {
        _this2.carouselNav.prev();
      });

      this.children.navigationNext.addEventListener('click', function () {
        _this2.carouselNav.next();
      });
    }

    /**
     * Set main carousel to the selected slide in navigation
     */

  }, {
    key: 'setCurrentSlide',
    value: function setCurrentSlide() {
      var _this3 = this;

      Array.prototype.forEach.call(this.children.navigationThumbs, function (thumb) {
        var thumbLink = thumb.querySelector('a');
        thumbLink.addEventListener('click', function (event) {
          event.preventDefault();
          _this3.carousel.goTo(parseInt(event.currentTarget.dataset.slideIndex, 10));
          _this3.setNavActiveClass(thumbLink.parentElement);
        });
      });
    }

    /**
     * Set a navigation slide to active
     * @param {HTML Element} activateElement the slide to become active
     */

  }, {
    key: 'setNavActiveClass',
    value: function setNavActiveClass(activateElement) {
      var _this4 = this;

      // Reset - Remove class from all existing active class
      Array.prototype.forEach.call(this.children.navigationThumbs, function (thumb) {
        thumb.classList.remove(_this4.options.navSlideActiveClass);
      });
      // Set active class to selected slide
      activateElement.classList.add(this.options.navSlideActiveClass);
    }
  }]);

  return Carousel;
}(_jsComponentFramework.Component);

exports.default = Carousel;

/***/ }),

/***/ "./client/js/components/Carousel/carouselConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Carousel = __webpack_require__("./client/js/components/Carousel/Carousel.js");

var _Carousel2 = _interopRequireDefault(_Carousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carouselConfig = {
  name: 'carousel',
  class: _Carousel2.default,
  querySelector: {
    viewport: '.carousel__viewport',
    navigationThumbWrapper: '.carousel__navigation-thumbs',
    navigationPrev: '.carousel__navigation-prev',
    navigationNext: '.carousel__navigation-next'
  },
  querySelectorAll: {
    navigationThumbs: '.carousel__navigation-thumb'
  },
  options: {
    navSlideActiveClass: 'carousel__navigation-thumb--active'
  }
};

exports.default = carouselConfig;

/***/ }),

/***/ "./client/js/components/DynamicIframe/DynamicIframe.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

var _Throttle = __webpack_require__("./client/js/utilities/Throttle.js");

var _Throttle2 = _interopRequireDefault(_Throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component that makes iframe element's height dynamic based on content.
 * Requires iframe source to share the same domain (prb.org)
 */
var DynamicIframe = function (_Component) {
  _inherits(DynamicIframe, _Component);

  /**
   * Instantiate component.
   * @param  {object} config Configuration object. @see index
   * @return {void}
   */
  function DynamicIframe(config) {
    _classCallCheck(this, DynamicIframe);

    // On init
    var _this = _possibleConstructorReturn(this, (DynamicIframe.__proto__ || Object.getPrototypeOf(DynamicIframe)).call(this, config));

    _this.updateHeight();

    // On frame load
    _this.element.onload = function () {
      _this.updateHeight();
    };

    // On resize
    _this.throttle = new _Throttle2.default(_this.updateHeight.bind(_this), 'resize', window, 1000);

    // On application finishing loading
    window.addEventListener('message', function (e) {
      if (e.data.updated) {
        _this.updateHeight();
      }
    }, false);
    return _this;
  }

  /**
   * Given an element, update the height of the element based on the height
   * of its inner frame.`
   * @return {void}
   */


  _createClass(DynamicIframe, [{
    key: 'updateHeight',
    value: function updateHeight() {
      try {
        // Pin vars for easy use
        var contentWindow = this.element.contentWindow;
        var documentElement = contentWindow.document.documentElement;
        var documentHeight = documentElement.scrollHeight;
        var bodyHeight = contentWindow.document.body.scrollHeight;

        // The new height should be the greater of the document or body heights
        var innerHeight = documentHeight > bodyHeight ? documentHeight : bodyHeight;

        // Update parent frame's style
        this.element.style.height = innerHeight + 'px';
        console.info('Updated iframe height to ' + innerHeight + 'px'); // eslint-disable-line no-console
      } catch (error) {
        console.warn( // eslint-disable-line no-console
        'Could not update iframe', this.element, error);
      }
    }
  }]);

  return DynamicIframe;
}(_jsComponentFramework.Component);

exports.default = DynamicIframe;

/***/ }),

/***/ "./client/js/components/DynamicIframe/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DynamicIframe = __webpack_require__("./client/js/components/DynamicIframe/DynamicIframe.js");

var _DynamicIframe2 = _interopRequireDefault(_DynamicIframe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dynamicIframe',
  class: _DynamicIframe2.default,
  querySelector: {},
  options: {}
};

/***/ }),

/***/ "./client/js/components/Footnotes/Footnotes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

var _SmoothScroll = __webpack_require__("./client/js/utilities/SmoothScroll.js");

var _SmoothScroll2 = _interopRequireDefault(_SmoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating Footnotes.
 */
var Footnotes = function (_Component) {
  _inherits(Footnotes, _Component);

  /**
   * Start the component
   */
  function Footnotes(config) {
    _classCallCheck(this, Footnotes);

    // Initalizations
    var _this = _possibleConstructorReturn(this, (Footnotes.__proto__ || Object.getPrototypeOf(Footnotes)).call(this, config));

    _this.footnotes = document.querySelectorAll('.footnote--slide');
    _this.setFootnotePointers();
    _this.setFootnoteIndex();
    _this.setSmoothScroll = new _SmoothScroll2.default('.footnote--slide');
    _this.setSmoothScroll.init();
    return _this;
  }

  /**
   * Set links and pointers in report body
   */


  _createClass(Footnotes, [{
    key: 'setFootnotePointers',
    value: function setFootnotePointers() {
      Array.prototype.forEach.call(this.footnotes, function (el) {
        var number = parseInt(el.textContent, 10);

        if (isNaN(number)) {
          return;
        }

        $(el).prepend('[').append(']');
        $(el).wrap('<a\n          id="footref-' + number + '"\n          class="sup footnote--slide"\n          href="#footnote-' + number + '"\n        >\n        </a>');
      });
    }

    /**
     * Set footnote index for ID
     */

  }, {
    key: 'setFootnoteIndex',
    value: function setFootnoteIndex() {
      Array.prototype.forEach.call(this.children.footnote, function (el, index) {
        var noteNumber = index + 1;
        var noteNumberHtml = '<a id="footnote-' + noteNumber + '"\n          class="footnote--slide"\n          href="#footref-' + noteNumber + '">\n          [' + noteNumber + ']&ensp;\n        </a>';

        el.insertAdjacentHTML('afterbegin', noteNumberHtml);
      });
    }
  }]);

  return Footnotes;
}(_jsComponentFramework.Component);

exports.default = Footnotes;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ "./client/js/components/Footnotes/footnotesConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footnotes = __webpack_require__("./client/js/components/Footnotes/Footnotes.js");

var _Footnotes2 = _interopRequireDefault(_Footnotes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footnotesConfig = {
  name: 'footnotes',
  class: _Footnotes2.default,
  querySelectorAll: {
    footnote: '.footnotes__list-item'
  }
};

exports.default = footnotesConfig;

/***/ }),

/***/ "./client/js/components/Header/ArticleToolbar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _headroom = __webpack_require__("./node_modules/headroom.js/dist/headroom.js");

var _headroom2 = _interopRequireDefault(_headroom);

var _jsComponentFramework = __webpack_require__("./node_modules/js-component-framework/lib/index.js");

var _Throttle = __webpack_require__("./client/js/utilities/Throttle.js");

var _Throttle2 = _interopRequireDefault(_Throttle);

var _SmoothScroll = __webpack_require__("./client/js/utilities/SmoothScroll.js");

var _SmoothScroll2 = _interopRequireDefault(_SmoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for instantiating Article Toolbar
 */
var ArticleToolbar = function (_Component) {
  _inherits(ArticleToolbar, _Component);

  /**
   * Start the component
   */
  function ArticleToolbar(config) {
    _classCallCheck(this, ArticleToolbar);

    // Init sticky Nav
    var _this = _possibleConstructorReturn(this, (ArticleToolbar.__proto__ || Object.getPrototypeOf(ArticleToolbar)).call(this, config));

    _this.headroom = new _headroom2.default(_this.element, _this.options.headroom);
    _this.headroom.init();

    // Throttle scroll event for progress bar
    _this.progressBarThrottle = new _Throttle2.default(_this.runProgressBar.bind(_this), 'scroll', document, 50);

    // Logo link smoothly scrolls user back to top
    _this.setSmoothScroll = new _SmoothScroll2.default('.article-toolbar__logo a');
    _this.setSmoothScroll.init();
    return _this;
  }

  /**
   * Determine y-position in window scroll and display in percentage bar
   * @see https://blog.andyjiang.com/reading-position-horizontal-progress-bar
   */


  _createClass(ArticleToolbar, [{
    key: 'runProgressBar',
    value: function runProgressBar() {
      var body = document.body;
      var html = document.documentElement;
      var winInnerHeight = window.innerHeight;
      var winYPosition = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var winMaxHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
      // Calculate y-position percentage
      var position = winYPosition / (winMaxHeight - winInnerHeight) * 100;

      this.children.progressBar.setAttribute('style', 'width:' + position + '%');
    }
  }]);

  return ArticleToolbar;
}(_jsComponentFramework.Component);

exports.default = ArticleToolbar;

/***/ }),

/***/ "./client/js/components/Header/articleToolbarConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ArticleToolbar = __webpack_require__("./client/js/components/Header/ArticleToolbar.js");

var _ArticleToolbar2 = _interopRequireDefault(_ArticleToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var articleToolbarConfig = {
  name: 'articleToolbar',
  class: _ArticleToolbar2.default,
  querySelector: {
    progressBar: '.article-toolbar__progress-bar'
  },
  options: {
    // Headroom.js config
    // @ref: http://wicky.nillia.ms/headroom.js/
    headroom: {
      // vertical offset in px before element is first unpinned
      offset: 600,
      // scroll tolerance in px before state changes
      tolerance: 5,
      // css classes to apply
      classes: {
        // when element is initialised
        initial: 'article-toolbar',
        // when scrolling down
        pinned: 'article-toolbar--slidedown',
        // when scrolling up
        unpinned: 'article-toolbar--slideup',
        // when above offset
        top: 'article-toolbar--top',
        // when below offset
        notTop: 'article-toolbar--not-top',
        // when at bottom of scoll area
        bottom: 'article-toolbar--bottom',
        // when not at bottom of scroll area
        notBottom: 'article-toolbar--not-bottom'
      }
    }
  }
};

exports.default = articleToolbarConfig;

/***/ }),

/***/ "./client/scss/article/loader.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/siema/dist/siema.min.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("Siema",[],t):"object"==typeof exports?exports.Siema=t():e.Siema=t()}(this,function(){return function(e){function t(s){if(i[s])return i[s].exports;var n=i[s]={i:s,l:!1,exports:{}};return e[s].call(n.exports,n,n.exports,t),n.l=!0,n.exports}var i={};return t.m=e,t.c=i,t.d=function(e,i,s){t.o(e,i)||Object.defineProperty(e,i,{configurable:!1,enumerable:!0,get:s})},t.n=function(e){var i=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(i,"a",i),i},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,i){"use strict";function s(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},r=function(){function e(e,t){for(var i=0;i<t.length;i++){var s=t[i];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,s.key,s)}}return function(t,i,s){return i&&e(t.prototype,i),s&&e(t,s),t}}(),o=function(){function e(t){var i=this;if(s(this,e),this.config=e.mergeSettings(t),this.selector="string"==typeof this.config.selector?document.querySelector(this.config.selector):this.config.selector,null===this.selector)throw new Error("Something wrong with your selector 😭");this.selectorWidth=this.selector.offsetWidth,this.innerElements=[].slice.call(this.selector.children),this.currentSlide=this.config.startIndex,this.transformProperty=e.webkitOrNot(),["resizeHandler","touchstartHandler","touchendHandler","touchmoveHandler","mousedownHandler","mouseupHandler","mouseleaveHandler","mousemoveHandler"].forEach(function(e){i[e]=i[e].bind(i)}),this.init()}return r(e,[{key:"attachEvents",value:function(){window.addEventListener("resize",this.resizeHandler),this.config.draggable&&(this.pointerDown=!1,this.drag={startX:0,endX:0,startY:0,letItGo:null},this.selector.addEventListener("touchstart",this.touchstartHandler,{passive:!0}),this.selector.addEventListener("touchend",this.touchendHandler),this.selector.addEventListener("touchmove",this.touchmoveHandler,{passive:!0}),this.selector.addEventListener("mousedown",this.mousedownHandler),this.selector.addEventListener("mouseup",this.mouseupHandler),this.selector.addEventListener("mouseleave",this.mouseleaveHandler),this.selector.addEventListener("mousemove",this.mousemoveHandler))}},{key:"detachEvents",value:function(){window.removeEventListener("resize",this.resizeHandler),this.selector.style.cursor="auto",this.selector.removeEventListener("touchstart",this.touchstartHandler),this.selector.removeEventListener("touchend",this.touchendHandler),this.selector.removeEventListener("touchmove",this.touchmoveHandler),this.selector.removeEventListener("mousedown",this.mousedownHandler),this.selector.removeEventListener("mouseup",this.mouseupHandler),this.selector.removeEventListener("mouseleave",this.mouseleaveHandler),this.selector.removeEventListener("mousemove",this.mousemoveHandler)}},{key:"init",value:function(){this.attachEvents(),this.resolveSlidesNumber(),this.selector.style.overflow="hidden",this.sliderFrame=document.createElement("div"),this.sliderFrame.style.width=this.selectorWidth/this.perPage*this.innerElements.length+"px",this.sliderFrame.style.webkitTransition="all "+this.config.duration+"ms "+this.config.easing,this.sliderFrame.style.transition="all "+this.config.duration+"ms "+this.config.easing,this.config.draggable&&(this.selector.style.cursor="-webkit-grab");for(var e=document.createDocumentFragment(),t=0;t<this.innerElements.length;t++){var i=document.createElement("div");i.style.cssFloat="left",i.style.float="left",i.style.width=100/this.innerElements.length+"%",i.appendChild(this.innerElements[t]),e.appendChild(i)}this.sliderFrame.appendChild(e),this.selector.innerHTML="",this.selector.appendChild(this.sliderFrame),this.slideToCurrent(),this.config.onInit.call(this)}},{key:"resolveSlidesNumber",value:function(){if("number"==typeof this.config.perPage)this.perPage=this.config.perPage;else if("object"===n(this.config.perPage)){this.perPage=1;for(var e in this.config.perPage)window.innerWidth>=e&&(this.perPage=this.config.perPage[e])}}},{key:"prev",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments[1];if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;0===this.currentSlide&&this.config.loop?this.currentSlide=this.innerElements.length-this.perPage:this.currentSlide=Math.max(this.currentSlide-e,0),i!==this.currentSlide&&(this.slideToCurrent(),this.config.onChange.call(this),t&&t.call(this))}}},{key:"next",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments[1];if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;this.currentSlide===this.innerElements.length-this.perPage&&this.config.loop?this.currentSlide=0:this.currentSlide=Math.min(this.currentSlide+e,this.innerElements.length-this.perPage),i!==this.currentSlide&&(this.slideToCurrent(),this.config.onChange.call(this),t&&t.call(this))}}},{key:"goTo",value:function(e,t){if(!(this.innerElements.length<=this.perPage)){var i=this.currentSlide;this.currentSlide=Math.min(Math.max(e,0),this.innerElements.length-this.perPage),i!==this.currentSlide&&(this.slideToCurrent(),this.config.onChange.call(this),t&&t.call(this))}}},{key:"slideToCurrent",value:function(){this.sliderFrame.style[this.transformProperty]="translate3d(-"+this.currentSlide*(this.selectorWidth/this.perPage)+"px, 0, 0)"}},{key:"updateAfterDrag",value:function(){var e=this.drag.endX-this.drag.startX,t=Math.abs(e),i=this.config.multipleDrag?Math.ceil(t/(this.selectorWidth/this.perPage)):1;e>0&&t>this.config.threshold&&this.innerElements.length>this.perPage?this.prev(i):e<0&&t>this.config.threshold&&this.innerElements.length>this.perPage&&this.next(i),this.slideToCurrent()}},{key:"resizeHandler",value:function(){this.resolveSlidesNumber(),this.selectorWidth=this.selector.offsetWidth,this.sliderFrame.style.width=this.selectorWidth/this.perPage*this.innerElements.length+"px",this.currentSlide+this.perPage>this.innerElements.length&&(this.currentSlide=this.innerElements.length-this.perPage),this.slideToCurrent()}},{key:"clearDrag",value:function(){this.drag={startX:0,endX:0,startY:0,letItGo:null}}},{key:"touchstartHandler",value:function(e){-1!==["TEXTAREA","OPTION","INPUT","SELECT"].indexOf(e.target.nodeName)||(e.stopPropagation(),this.pointerDown=!0,this.drag.startX=e.touches[0].pageX,this.drag.startY=e.touches[0].pageY)}},{key:"touchendHandler",value:function(e){e.stopPropagation(),this.pointerDown=!1,this.sliderFrame.style.webkitTransition="all "+this.config.duration+"ms "+this.config.easing,this.sliderFrame.style.transition="all "+this.config.duration+"ms "+this.config.easing,this.drag.endX&&this.updateAfterDrag(),this.clearDrag()}},{key:"touchmoveHandler",value:function(e){e.stopPropagation(),null===this.drag.letItGo&&(this.drag.letItGo=Math.abs(this.drag.startY-e.touches[0].pageY)<Math.abs(this.drag.startX-e.touches[0].pageX)),this.pointerDown&&this.drag.letItGo&&(e.preventDefault(),this.drag.endX=e.touches[0].pageX,this.sliderFrame.style.webkitTransition="all 0ms "+this.config.easing,this.sliderFrame.style.transition="all 0ms "+this.config.easing,this.sliderFrame.style[this.transformProperty]="translate3d("+-1*(this.currentSlide*(this.selectorWidth/this.perPage)+(this.drag.startX-this.drag.endX))+"px, 0, 0)")}},{key:"mousedownHandler",value:function(e){-1!==["TEXTAREA","OPTION","INPUT","SELECT"].indexOf(e.target.nodeName)||(e.preventDefault(),e.stopPropagation(),this.pointerDown=!0,this.drag.startX=e.pageX)}},{key:"mouseupHandler",value:function(e){e.stopPropagation(),this.pointerDown=!1,this.selector.style.cursor="-webkit-grab",this.sliderFrame.style.webkitTransition="all "+this.config.duration+"ms "+this.config.easing,this.sliderFrame.style.transition="all "+this.config.duration+"ms "+this.config.easing,this.drag.endX&&this.updateAfterDrag(),this.clearDrag()}},{key:"mousemoveHandler",value:function(e){e.preventDefault(),this.pointerDown&&(this.drag.endX=e.pageX,this.selector.style.cursor="-webkit-grabbing",this.sliderFrame.style.webkitTransition="all 0ms "+this.config.easing,this.sliderFrame.style.transition="all 0ms "+this.config.easing,this.sliderFrame.style[this.transformProperty]="translate3d("+-1*(this.currentSlide*(this.selectorWidth/this.perPage)+(this.drag.startX-this.drag.endX))+"px, 0, 0)")}},{key:"mouseleaveHandler",value:function(e){this.pointerDown&&(this.pointerDown=!1,this.selector.style.cursor="-webkit-grab",this.drag.endX=e.pageX,this.sliderFrame.style.webkitTransition="all "+this.config.duration+"ms "+this.config.easing,this.sliderFrame.style.transition="all "+this.config.duration+"ms "+this.config.easing,this.updateAfterDrag(),this.clearDrag())}},{key:"updateFrame",value:function(){this.sliderFrame=document.createElement("div"),this.sliderFrame.style.width=this.selectorWidth/this.perPage*this.innerElements.length+"px",this.sliderFrame.style.webkitTransition="all "+this.config.duration+"ms "+this.config.easing,this.sliderFrame.style.transition="all "+this.config.duration+"ms "+this.config.easing,this.config.draggable&&(this.selector.style.cursor="-webkit-grab");for(var e=document.createDocumentFragment(),t=0;t<this.innerElements.length;t++){var i=document.createElement("div");i.style.cssFloat="left",i.style.float="left",i.style.width=100/this.innerElements.length+"%",i.appendChild(this.innerElements[t]),e.appendChild(i)}this.sliderFrame.appendChild(e),this.selector.innerHTML="",this.selector.appendChild(this.sliderFrame),this.slideToCurrent()}},{key:"remove",value:function(e,t){if(e<0||e>=this.innerElements.length)throw new Error("Item to remove doesn't exist 😭");e<this.currentSlide&&this.currentSlide--,this.innerElements.splice(e,1),this.updateFrame(),t&&t.call(this)}},{key:"insert",value:function(e,t,i){if(t<0||t>this.innerElements.length+1)throw new Error("Unable to inset it at this index 😭");if(-1!==this.innerElements.indexOf(e))throw new Error("The same item in a carousel? Really? Nope 😭");var s=t<=this.currentSlide>0&&this.innerElements.length;this.currentSlide=s?this.currentSlide+1:this.currentSlide,this.innerElements.splice(t,0,e),this.updateFrame(),i&&i.call(this)}},{key:"prepend",value:function(e,t){this.insert(e,0),t&&t.call(this)}},{key:"append",value:function(e,t){this.insert(e,this.innerElements.length+1),t&&t.call(this)}},{key:"destroy",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=arguments[1];if(this.detachEvents(),e){for(var i=document.createDocumentFragment(),s=0;s<this.innerElements.length;s++)i.appendChild(this.innerElements[s]);this.selector.innerHTML="",this.selector.appendChild(i),this.selector.removeAttribute("style")}t&&t.call(this)}}],[{key:"mergeSettings",value:function(e){var t={selector:".siema",duration:200,easing:"ease-out",perPage:1,startIndex:0,draggable:!0,multipleDrag:!0,threshold:20,loop:!1,onInit:function(){},onChange:function(){}},i=e;for(var s in i)t[s]=i[s];return t}},{key:"webkitOrNot",value:function(){return"string"==typeof document.documentElement.style.transform?"transform":"WebkitTransform"}}]),e}();t.default=o,e.exports=t.default}])});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./client/js/article/article.js");


/***/ })

},[4]);


// WEBPACK FOOTER //
// js/article.46d7bf5.bundle.min.js